import type { FaireProductEntity } from "../../entity_types/product";

export const atc_baggu_1: FaireProductEntity = {
  token: "atc_baggu_1",
  type: "product",
  name: "Puffy Tote - Extra Pink",
  brandName: "Baggu",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c3a6a109a1b77cc1a7f7dc54a760fab7947e7e51ad64e5361f24158b1765df1b.jpeg",
  priceDollars: 20,
  msrpDollars: 42,
  description: "Reusable bag made from recycled materials by Baggu.",
  tags: ["bags", "accessories", "sustainable"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
